import "./styles.css";

import { useState, useEffect } from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import React from "react";
import xbgall from "../../img/instructions/xbgall.jpg";
import android_1 from "../../img/instructions/android/android_1.jpg";
import android_2 from "../../img/instructions/android/android_2.jpg";
import android_3 from "../../img/instructions/android/android_3.jpg";

import ios_1 from "../../img/instructions/ios/ios_1.jpg";
import ios_2 from "../../img/instructions/ios/ios_2.jpg";
import ios_3 from "../../img/instructions/ios/ios_3.jpg";
import cat_img from "../../img/info/cat_info.png";
import ButtonHead from "../buttonHead";

const InfoPage = () => {
  const navigate = useNavigate();
  useEffect(() => {}, []);

  return (
    <div className="wrapper">
      <ButtonHead />
      <div className="info">
        <h1>Важная информация</h1>
        <div className="info-title">
          <p> Привет Друзья!</p>
          <p className="warning-red">
            Приложения "не украли" и "срок аренды" их не вышел, в чем вас
            пытаются убедить!
          </p>
          <p>
            Немного про меня, меня зовут Дима и на протяжении 6-ти лет, я был
            частью команды и был с вами каждый день. Если вы производили покупки
            или задавали вопросы в дневное время, 100% вы общались со мной.
          </p>
          <p>
            Так сложилась ситуация что разошлись во взглядах с "хозяином" группы
            XBOGames. И он меня предательски удалил из всех групп, в которые
            было вложено очень много сил и время, включая и эти приложения. С
            таким человеком, я ничего общего больше иметь не хочу.
          </p>
          <p>Ну что ж, всякое случается.</p>
          <React.Fragment>
            <br />
          </React.Fragment>
          <p className="italic">
            Асгард — не точка в пространстве, не место. Чем здесь не Асгард?
            Асгард там, где асгардцы. (с)Тор: Рагнарёк
          </p>
          <React.Fragment>
            <br />
          </React.Fragment>
          <p>
            {" "}
            Все приложения (
            <a
              onClick={() => {
                navigate("/xcalc");
              }}
            >
              поиск
            </a>
            ,{" "}
            <a
              onClick={() => {
                navigate("/deals");
              }}
            >
              актуальные скидки
            </a>
            ,{" "}
            <a
              onClick={() => {
                navigate("/donate");
              }}
            >
              игровая валюта
            </a>{" "}
            ) как работали так и будут работать, цены актуальны для покупки в{" "}
            <a
              href="https://vk.com/life4play1"
              target="_blank"
              rel="noopener noreferrer"
            >
              новом Асгарде
            </a>{" "}
            , подписывайтесь:{" "}
            <a
              href="https://vk.com/life4play1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Life4Play ( Xbox One, Series S|X )
            </a>
          </p>
          <React.Fragment>
            <br />
          </React.Fragment>
          <p>
            Сервис остаётся на том же уровне, но с небольшой поправкой: быстро,
            качественно, <span className="line-through">дорого</span> дешево!{" "}
          </p>
          <React.Fragment>
            <br />
          </React.Fragment>
          <p> Добро пожаловать! </p>
          <p>И как я говорил на протяжении 6 лет:</p>
          <p className="italic"> Всегда рады помочь!</p>
          <p className="italic">Если что обращайтесь!</p>
          <div className="wrapper_cat">
            <img className="img_cat" src={cat_img} alt="cat" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
